import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "step-title-container"
}
const _hoisted_2 = { class: "page-wr" }
const _hoisted_3 = {
  key: 0,
  class: "main-container"
}
const _hoisted_4 = {
  key: 0,
  class: "total-results"
}
const _hoisted_5 = { class: "total-results-text" }
const _hoisted_6 = { class: "cards-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$setup.isDesktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode($setup["BuilderEstimatorStepTitle"], { title: "House Designs" })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      ($setup.props.houses.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode($setup["HouseDesignFilter"], {
              houses: $setup.props.houses,
              "onUpdate:filteredHouses": $setup.updateHouses
            }, null, 8, ["houses"]),
            (!$setup.isDesktop)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString($setup.houses.length) + " Results:", 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.houses, (house) => {
                return (_openBlock(), _createBlock($setup["HouseDesignCard"], {
                  key: house._id,
                  house: house,
                  onViewFloorPlan: $setup.handleViewFloorPlan
                }, null, 8, ["house"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}